import { getApplicationStep } from "../../modules/app/utils/getApplicationStep";

export const createMetricName = (fieldName) => {
  const step = getApplicationStep();
  return fieldName ? step.toLowerCase() + '_' + fieldName : fieldName;
  //return fieldName ? fieldName+'_salamatov' : fieldName;
}
